/**
 * web模块的collections里面的类型通过泛型约束来控制
 */
export const collections = {
    /** xenv */
    xenv: true,
    is: true,
    /* isHK */
    isHK: true,
    /** init */
    init: true,
    /** login */
    login: {
        alimp: true,
        alipay: true,
        capp: true,
        cowxmp: true,
        cxwxmp: true,
        sfcwxmp: true,
        driver: true,
        drwxmp: true,
        gjwxmp: true,
        h5: true,
        kfalimp: true,
        kfdriver: true,
        kfdwxmp: true,
        kfpassenger: true,
        kfwxmp: true,
        mqq: true,
        passenger: true,
        qjwxmp: true,
        thwxmp: true,
        weixin: true,
        wxmp: true,
        yxwxmp: true,
        esapp: true,
        hitchapp: true,
        hywxmp: true,
        hydriver: true
    },
    isLogin: {
        alimp: true,
        alipay: true,
        capp: true,
        cowxmp: true,
        cxwxmp: true,
        sfcwxmp: true,
        driver: true,
        drwxmp: true,
        gaswxmp: true,
        gjwxmp: true,
        h5: true,
        kfalimp: true,
        kfdriver: true,
        kfdwxmp: true,
        kfpassenger: true,
        kfwxmp: true,
        mqq: true,
        passenger: true,
        qjwxmp: true,
        qqmp: true,
        thwxmp: true,
        weixin: true,
        wxmp: true,
        yxwxmp: true,
        esapp: true,
        hitchapp: true,
        hywxmp: true,
        hydriver: true
    },
    loginCheckPhone: {
        alipay: true,
        mqq: true,
        h5: true,
        weixin: true
    },
    setLoginConfig: {
        alimp: true,
        alipay: true,
        bdmp: true,
        capp: true,
        cowxmp: true,
        cxwxmp: true,
        sfcwxmp: true,
        driver: true,
        drwxmp: true,
        gaswxmp: true,
        gjwxmp: true,
        h5: true,
        kfalimp: true,
        kfdriver: true,
        kfdwxmp: true,
        kfpassenger: true,
        kfwxmp: true,
        mqq: true,
        passenger: true,
        qjwxmp: true,
        qqmp: true,
        thwxmp: true,
        weixin: true,
        wxmp: true,
        yxwxmp: true,
        hitchapp: true,
        hywxmp: true,
        hydriver: true
    },
    logout: {
        alipay: true,
        driver: true,
        kfdriver: true,
        mqq: true,
        h5: true,
        weixin: true
    },
    loginSDK: {
        alipay: true,
        driver: true,
        kfdriver: true,
        mqq: true,
        h5: true,
        weixin: true
    },
    /** locate */
    locate: {
        alimp: true,
        alipay: true,
        capp: true,
        cowxmp: true,
        cxwxmp: true,
        sfcwxmp: true,
        driver: true,
        drwxmp: true,
        gaswxmp: true,
        gjwxmp: true,
        h5: true,
        kfalimp: true,
        kfdriver: true,
        kfdwxmp: true,
        kfpassenger: true,
        kfwxmp: true,
        mqq: true,
        passenger: true,
        qjwxmp: true,
        thwxmp: true,
        weixin: true,
        wxmp: true,
        yxwxmp: true,
        esapp: true,
        hitchapp: true,
        hywxmp: true,
        hydriver: true
    },
    /** share */
    setShare: {
        alimp: true,
        kfwxmp: true,
        cxwxmp: true,
        sfcwxmp: true,
        driver: true,
        gaswxmp: true,
        kfdriver: true,
        kfpassenger: true,
        passenger: true,
        qjwxmp: true,
        weixin: true,
        wxmp: true,
        yxwxmp: true,
        hitchapp: true,
        hywxmp: true
    },
    invokeShare: {
        alimp: true,
        alipay: true,
        cxwxmp: true,
        driver: true,
        sfcwxmp: true,
        gaswxmp: true,
        kfdriver: true,
        kfpassenger: true,
        kfwxmp: true,
        passenger: true,
        qjwxmp: true,
        weixin: true,
        wxmp: true,
        yxwxmp: true,
        hitchapp: true,
        hywxmp: true
    },
    /** omega */
    setOmegaConfig: true,
    setOmegaAttrs: true,
    trackEvent: true,
    sendXspmScan: true,
    sendXspmClick: true,
    trackPageShow: true,
    trackResourceEvent: true,
    trackResourceExposure: true,
    getOmega: true,
    /** request */
    request: true,
    get: true,
    post: true,
    postEncrypt: true,
    /** webx */
    getPageConfig: true,
    getShareConfig: true,
    getXaidConfig: true,
    getSessionParams: true,
    /** goto */
    goTo: true,
    /** subscribe */
    subscribeInit: false,
    tryToSubscribe: false,
    getAlwaysSubscribeStatus: false,
    subscribe: {
        cowxmp: true,
        cxwxmp: true,
        sfcwxmp: true,
        drwxmp: true,
        gjwxmp: true,
        kfdwxmp: true,
        kfwxmp: true,
        qjwxmp: true,
        thwxmp: true,
        wxmp: true,
        yxwxmp: true,
        hywxmp: true
    },
    /** query */
    build: true,
    buildSearch: true,
    query: true,
    hashBuild: true,
    hashQuery: true,
    parseURL: true,
    /** openid */
    getOpenid: false,
    /** bridge */
    bridge: true,
    dbridge: true,
    kfdbridge: true,
    weixinReady: {
        cowxmp: true,
        cxwxmp: true,
        sfcwxmp: true,
        drwxmp: true,
        gjwxmp: true,
        kfdwxmp: true,
        kfwxmp: true,
        qjwxmp: true,
        thwxmp: true,
        weixin: true,
        wxmp: true,
        yxwxmp: true,
        hitchapp: true,
        hywxmp: true
    },
    alipayReady: {
        alimp: true,
        kfalimp: true
    },
    weixinmpReady: {
        cowxmp: true,
        cxwxmp: true,
        sfcwxmp: true,
        drwxmp: true,
        gjwxmp: true,
        kfdwxmp: true,
        kfwxmp: true,
        qjwxmp: true,
        thwxmp: true,
        wxmp: true,
        yxwxmp: true,
        hitchapp: true,
        hywxmp: true
    },
    alimpReady: {
        alimp: true,
        kfalimp: true
    },
    mqqReady: {
        qqmp: true
    },
    /** loader */
    loadScript: true,
    sdkReady: true,
    /** saveImg */
    saveImg: {
        driver: true,
        kfdriver: true,
        passenger: true,
        hitchapp: true,
        hydriver: true
    },
    /** storage */
    storage: true,
    /* getEnvInfo */
    getEnvInfo: true,
    /** userInfo */
    userInit: false,
    reportUserInfo: false,
    queryReportStatus: false,
    /** pay */
    pay: {
        alipay: true,
        alimp: true,
        h5: true,
        weixin: true,
        wxmp: true,
        passenger: true,
        kfpassenger: true,
        yxwxmp: true,
        esapp: true,
        hitchapp: true,
        hywxmp: true,
        qjwxmp: true,
        sfcwxmp: true
    },
    getPayInfo: false,
    /** launchApp */
    launchApp: true,
    /* version */
    getVersion: true,
    compareVersion: true
};
